import React, { useEffect, useState } from "react";
import StudentsTable from "./StudentsTable";
import SearchSec from "./SearchSec";
import { Pagination } from "antd";
import Utils from "../../../../../../utils/Utils";
import WebUtils from "../../../../../../utils/WebUtils";
import { getAssignedCandidatesApi } from "../../../../../../api/org-admin";
import UnassignStudentModal from "./unassignGuideModal/UnassignStudentModal";

const TableMain = ({
  userDetail,
  setLoading,
  jobGuideIdentifier,
  getGuideDetails,
}) => {
  const [studentsData, setStudentsData] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [sortBy, setSortBy] = useState("SORT_BY_ASSIGNED_DATE_DESC");
  const [currentPage, setCurrentPage] = useState(0);
  const [pageCount, setPageCount] = useState(5);
  const [pageSize, setPageSize] = useState(5);
  const [selectedUserIds, setSelectedUserIds] = useState([]);
  const [unAssignStudentFlag, setUnAssignStudentFlag] = useState(false);
  const [batchIdsFilter, setBatchIdsFilter] = useState(null);

  const getStudents = (pageNo, pageSize, searchInput) => {
    const url = `${getAssignedCandidatesApi}?organizationId=${
      userDetail?.organizationId || null
    }&jobGuideIdentifier=${jobGuideIdentifier}&pageNumber=${pageNo}&pageSize=${pageSize}&searchInput=${searchInput}`;
    setLoading(true);

    let req = {
      sortBy: sortBy,
      batchIds: batchIdsFilter,
    };

    WebUtils.httpOperations(url, req, "POST")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          setStudentsData(result?.data?.data?.candidateList);
          setPageCount(result?.data?.data?.totalCount);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const refreshApis = () => {
    getGuideDetails();
    getStudents(0, 5, "");
  };

  const onPageChange = (num, pageSize) => {
    setCurrentPage(num - 1);
    setPageSize(pageSize);
  };



  useEffect(() => {
    getStudents(currentPage, pageSize, searchValue);
  }, [pageSize, currentPage, sortBy, searchValue, batchIdsFilter]);

  return (
    <div className="mt-3">
      <>
        {unAssignStudentFlag && (
          <UnassignStudentModal
            unAssignStudentFlag={unAssignStudentFlag}
            setUnAssignStudentFlag={setUnAssignStudentFlag}
            setLoading={setLoading}
            selectedUserIds={selectedUserIds}
            refreshApis={refreshApis}
          />
        )}
        <SearchSec
          searchText={searchText}
          setSearchText={setSearchText}
          studentsData={studentsData}
          setSearchValue={setSearchValue}
          searchValue={searchValue}
          selectedUserIds={selectedUserIds}
          refreshApis={refreshApis}
          unAssignStudentFlag={unAssignStudentFlag}
          setUnAssignStudentFlag={setUnAssignStudentFlag}
          sortBy={sortBy}
          setSortBy={setSortBy}
          jobGuideIdentifier={jobGuideIdentifier}
          setBatchIdsFilter={setBatchIdsFilter}
          batchIdsFilter={batchIdsFilter}
        />
        <StudentsTable
          studentsData={studentsData}
          setSelectedUserIds={setSelectedUserIds}
          selectedUserIds={selectedUserIds}
          unAssignStudentFlag={unAssignStudentFlag}
          setUnAssignStudentFlag={setUnAssignStudentFlag}
        />
        <div className="flex justify-center mt-3 mb-1">
          <Pagination
            current={currentPage + 1}
            total={pageCount}
            pageSize={pageSize}
            onChange={onPageChange}
            showSizeChanger={true} // ✅ enable page size selector
            pageSizeOptions={["5", "10", "15", "20"]} // options for items per page
          />
        </div>
      </>
    </div>
  );
};

export default TableMain;
